import { lazy } from 'react';

const CharityVettingSocialAccountsEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingSocialAccounts" */ '../components/steps/social-accounts-step/SocialAccounts'
    ),
);

export default CharityVettingSocialAccountsEntry;
